angular
    .module('MW.Dashboard.WidgetComponents', [
        'MW.Dashboard.TextWidget',
        'MW.Dashboard.ImageWidget',
        'MW.Search.SearchListWidget',
        'MW.v11n.WorldclickheatWidget',
        'MW.InsDashboard.AveWidget',
        'MW.InsDashboard.GeoSegmentWidget',
        'MW.InsDashboard.BubbleD3',
        'MW.InsDashboard.KeyphraseTrendWidget',
        'MW.InsDashboard.MomentumD3',
        'MW.InsDashboard.reachWidget',
        'MW.InsDashboard.AvgSentimentWidget',
        'MW.InsDashboard.SentimentWidget',
        'MW.InsDashboard.sourceSegmentWidget',
        'MW.InsDashboard.sovWidget',
        'MW.InsDashboard.topLangWidget',
        'MW.InsDashboard.TopPostersWidget',
        'MW.InsDashboard.volumeWidget',
        'MW.InsDashboard.MomentumWidget',
        'MW.InsDashboard.googleAnalyticsWidget',
        'MW.InsDashboard.SocialReachWidget'
    ])
    .directive('widgetLoader', ['$compile','DashboardStateService', '$timeout', '$window', function($compile, DashboardStateService, $timeout, $window){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            widget: '=?',
            widgetView: '@',
            reportType: '@',
            reportContentType: '@?',
            exportType: '@?'
        },
        link: function(scope, iElement, iAttrs){
            scope.reportType = scope.reportType || 'none';
            scope.exportType = scope.exportType || 'default';

            var loaded = false;
            scope.$watch('widget.id', function() {
                if(typeof(scope.widget) !== 'undefined'){
                    scope.dashboard = DashboardStateService.currentDashboard;
                    if(!scope.containerIndex){
                        scope.containerIndex = 0;
                    }
                    if(typeof scope.dashboard.containers != 'undefined'){
                        scope.container = scope.dashboard.containers[scope.containerIndex];
                    }
                    scope.compileElement(scope, iElement);
                    loaded = true;
                }
            });

            var windowResizeTimeout = null;


            if(scope.widgetView === 'maximized'){
                DashboardStateService.refreshCache = true;
                angular.element($window).on('resize.widget', function handleWindowResize() {
                    if (windowResizeTimeout !== null) {
                        $timeout.cancel(windowResizeTimeout);
                        windowResizeTimeout = null;
                    }

                    windowResizeTimeout = $timeout(function doWindowResizeDashboard() {
                        scope.$broadcast('widgetResized');
                        windowResizeTimeout = null;
                    }, 500);
                });
            }

            scope.$on('$destroy', function(){
                angular.element($window).off('resize.widget');
            });
        },
        controller: ['$scope','DashboardStateService', function($scope, DashboardStateService) {
            $scope.compileElement = function(scope, element) {
                element.html($compile('<' + scope.widget.directive + ' widget-view="' + $scope.widgetView +'"></'+scope.widget.directive+'>')(scope));
            };

        }]
    };
}]).filter('foundationWidth', function () {
    return function (input) {
        var foundationClasses = ' columns';
        if(parseInt(input) === 1)
            return 'one' + foundationClasses;
        else if(parseInt(input) === 2)
            return 'two' + foundationClasses;
        else if(parseInt(input) === 3)
            return 'three' + foundationClasses;
        else if(input === 'third' || parseInt(input) === 4)
            return 'four' + foundationClasses;
        else if(parseInt(input) === 5)
            return 'five' + foundationClasses;
        else if(input === 'half' || parseInt(input) === 6)
            return 'six' + foundationClasses;
        else if(parseInt(input) === 7)
            return 'seven' + foundationClasses;
        else if(input === 'twothirds' || parseInt(input) === 8)
            return 'eight' + foundationClasses;
        else if(parseInt(input) === 9)
            return 'nine' + foundationClasses;
        else if(parseInt(input) === 10)
            return 'ten' + foundationClasses;
        else if(parseInt(input) === 11)
            return 'eleven' + foundationClasses;
        else // 12
            return 'twelve' + foundationClasses;
    };
  });
